/**
 * This is our TypeScript entry-point. Everything starts here.
 * 
 * @package get-go
 * @since 1.0.0
 */

// Import a demonstration component
import './components/Accordion';
import './components/CompletePillarToggle';
import './components/CompleteStageToggle';
import './components/MatchHeight';
import './components/MobileMenu';
import './components/ModuleNotes';
import './components/PDFViewer';



// WEBPACK FOOTER //
// ./resources/assets/scripts/app.ts